import imgVilela from '../Assets/image/Card/Farm_Vilela/farmacia1.jpg';
import imgRP from '../Assets/image/Card/Farm_RP/farmacia2.jpg';
import imgParadiñeiro from '../Assets/image/Card/Farm_Paradiñeiro/farmacia3.jpg';
import imgCallao from '../Assets/image/Card/Farm_Callao/farmacia4.jpg';
import imgBotica from '../Assets/image/Card/Farm_Botica/farmacia5.jpg';

export const farmacias = [
  { id: 1, nombre: 'Farmacia Vilela', imagen: imgVilela, ubicacion: 'San Justo'},
  { id: 2, nombre: 'Farmacia RP', imagen: imgRP, ubicacion: 'Ciudad Autonoma de Buenos Aires'},
  { id: 3, nombre: 'Farmacia Paradiñeiro', imagen: imgParadiñeiro, ubicacion: 'Pilar' },
  { id: 4, nombre: 'Farmacia Callao', imagen: imgCallao, ubicacion: 'Ciudad Autonoma de Buenos Aires'},
  { id: 5, nombre: 'Farmacia La Botica', imagen: imgBotica, ubicacion: 'Ciudad Autonoma de Buenos Aires'},  
];